import TargetProperty from './TargetProperty';

export default TargetProperty;
